"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirstName = FirstName;
exports.LastName = LastName;
exports.IsEotEligable = IsEotEligable;
exports.IsAccountClosedNotEditable = IsAccountClosedNotEditable;
exports.IsAccountOpenEditable = IsAccountOpenEditable;
exports.IsDisabled = IsDisabled;
exports.IsEditable = IsEditable;
exports.IsDueDateEligible = IsDueDateEligible;
exports.IsAutoPayEligible = IsAutoPayEligible;
exports.IsFisAutoPayEligible = IsFisAutoPayEligible;
exports.IsOneTimePaymentEligible = IsOneTimePaymentEligible;
exports.IsCurtailmentPaymentEligible = IsCurtailmentPaymentEligible;
exports.IsPastDue = IsPastDue;
exports.MaturesWithin30Days = MaturesWithin30Days;
exports.TodayAddDays = TodayAddDays;
exports.DateDiff = DateDiff;
const enums_1 = require("./enums");
function FirstName(firstName, lastName) {
    let name = lastName;
    if (firstName != null) {
        name = firstName;
    }
    return name;
}
function LastName(firstName, lastName) {
    let name = lastName;
    if (firstName == null) {
        name = null;
    }
    return name;
}
function IsEotEligable(input) {
    return (input.Country === enums_1.VciCountry.USA &&
        input.TerminationStatus === enums_1.TerminationStatus.Terminated &&
        input.DaysDelinquent < 70 &&
        input.Payment.CurrentBalance > 0);
}
function IsAccountClosedNotEditable(input) {
    const inactiveRule1 = input.AccountStatus === enums_1.AccountStatus.Closed;
    const inactiveRule2 = input.AccountStatus === enums_1.AccountStatus.PaidOff;
    const inactiveRule3 = input.AccountStatus === enums_1.AccountStatus.Active && input.TerminationStatus === enums_1.TerminationStatus.Terminated && input.Payment.CurrentBalance === 0;
    return inactiveRule1 || inactiveRule2 || inactiveRule3;
}
function IsAccountOpenEditable(input) {
    return (input.AccountStatus === enums_1.AccountStatus.Active &&
        input.ProcessStatus !== enums_1.ProcessStatus.FullyChargedOff &&
        input.ProcessStatus !== enums_1.ProcessStatus.PartiallyChargedOff &&
        input.TermTypeStatus !== enums_1.TermTypeStatus.TerminationByPayoff);
}
function IsDisabled(input) {
    const disabledPerRule1 = input.AccountStatus == enums_1.AccountStatus.Active &&
        (input.RepossessionStatus == enums_1.ReposessionStatus.Repossessed ||
            input.DaysDelinquent > 69 ||
            input.ProcessStatus == enums_1.ProcessStatus.FullyChargedOff ||
            input.ProcessStatus == enums_1.ProcessStatus.PartiallyChargedOff ||
            input.BankruptcyStatus == enums_1.BankruptcyStatus.Bankrupt);
    const disabledPerRule2 = (input.AccountStatus === enums_1.AccountStatus.Closed || input.AccountStatus === enums_1.AccountStatus.PaidOff) && DateDiff(input.AccountStatusDate) > 45;
    const disabledPerRule3 = input.AccountStatus == enums_1.AccountStatus.Active &&
        input.TerminationStatus == enums_1.TerminationStatus.Terminated &&
        input.Payment.CurrentBalance == 0 &&
        DateDiff(input.AccountStatusDate) > 45;
    return disabledPerRule1 || disabledPerRule2 || disabledPerRule3;
}
function IsEditable(input) {
    return input.IsDisabled === false && input.IsAccountOpenEditable;
}
// context.Destination.IsDueDateEligible = (
//   (src.ProductType.DetailedAccountType == AccountType.Lease || src.ProductType.DetailedAccountType == AccountType.Loan) &&
//   src.DaysDelinquent <= 0 &&
//   src.CurrentMaturityDate == src.OriginalMaturityDate &&
//   src.RemainingTerm > 2 &&
//   src.BankruptcyStatus == "NotBankrupt" &&
//   src.AccountStatus == "Active" &&
//   src.TerminationStatus == "NotTerminated" &&
//   src.ReposessionStatus == "NotRepossessed" &&
//   src.FlatCancelStatus == "NotFlatCancelled"
// );
function IsDueDateEligible(input) {
    return ((input.Finance.AccountType === enums_1.AccountType.Lease || input.Finance.AccountType === enums_1.AccountType.Loan) &&
        input.DaysDelinquent <= 0 &&
        input.CurrentMaturityDate.getTime() == input.OriginalMaturityDate.getTime() &&
        input.Payment.PaymentsRemaining > 2 &&
        input.BankruptcyStatus === enums_1.BankruptcyStatus.NotBankrupt &&
        input.AccountStatus === enums_1.AccountStatus.Active &&
        input.TerminationStatus === enums_1.TerminationStatus.NotTerminated &&
        input.RepossessionStatus === enums_1.ReposessionStatus.NotRepossessed &&
        input.FlatCancelStatus === enums_1.FlatCancelStatus.NotFlatCancelled);
}
// IsAutoPayEligible = isPastDue || isAlreadyAutoPay || hasNoCurrentDueDate || maturesWithin30Days || isEotEligable
// isAlreadyAutoPay This comes from ELVIS which currently stores autopay data
// this is most of the calulation, you'll need the flag from ELVIS to finish it
function IsAutoPayEligible(input) {
    return input.IsPastDue ||
        input.IsAutoPayActive ||
        input.Payment.DueAmount.Current.DueDate == null ||
        MaturesWithin30Days(input) ||
        input.IsEotEligible
        ? false
        : true;
}
//This does the calculation to determine if its elgiible based on data from FIS only see IsAutoPayEligible for the full rule
function IsFisAutoPayEligible(input) {
    return input.IsPastDue || input.Payment.DueAmount.Current.DueDate == null || MaturesWithin30Days(input) || input.IsEotEligible ? false : true;
}
//isNonSufficientFundsGt5 || isEotEligable
function IsOneTimePaymentEligible(input) {
    return input.Payment.NsfCount > 5 || input.IsEotEligible ? false : true;
}
// return (accountStatus.Equals(AccountStatus.Active.ToString()) &&
// ProductType.DetailedAccountType.Equals(AccountType.Loan))
// !processingStatus.Equals(ProcessStatus.FullyChargedOff.ToString()) &&
// !processingStatus.Equals(ProcessStatus.PartiallyChargedOff.ToString()) &&
// !termTypeStatus.Equals(TermTypeStatus.TerminationByPayoff.ToString()));
function IsCurtailmentPaymentEligible(input) {
    return (input.Finance.AccountType === enums_1.AccountType.Loan &&
        input.AccountStatus === enums_1.AccountStatus.Active &&
        input.ProcessStatus !== enums_1.ProcessStatus.FullyChargedOff &&
        input.ProcessStatus !== enums_1.ProcessStatus.PartiallyChargedOff &&
        input.TermTypeStatus !== enums_1.TermTypeStatus.TerminationByPayoff);
}
// private bool GetIsPastDue(Account source)
// {
//     var isPastDue = false;
//     if (source.PastDueDate.HasValue)
//     {
//         if (DateTime.Today.DayOfWeek == DayOfWeek.Sunday || DateTime.Today.DayOfWeek == DayOfWeek.Monday)
//         {
//             if ((source.PastDueDate.Value.DayOfWeek == DayOfWeek.Saturday || source.PastDueDate.Value.DayOfWeek == DayOfWeek.Sunday) && source.DaysDelinquent == 0)
//             {
//                 isPastDue = false;
//             }
//             else if (source.PastDueDate.Value < DateTime.Today)
//             {
//                 isPastDue = true;
//             }
//         }
//         else if (source.PastDueDate.Value < DateTime.Today)
//         {
//             isPastDue = true;
//         }
//     }
//     return isPastDue;
// }
function IsPastDue(input) {
    var _a, _b;
    if (input.Payment.DueAmount.Past.DueDate == null) {
        return false;
    }
    // Sunday - Saturday : 0 - 6
    if ((((_a = input.Payment.DueAmount.Past.DueDate) === null || _a === void 0 ? void 0 : _a.getDay()) === 0 || ((_b = input.Payment.DueAmount.Past.DueDate) === null || _b === void 0 ? void 0 : _b.getDay()) === 6) && input.DaysDelinquent === 0) {
        return false;
    }
    // Get the current date in UTC and set the time to midnight (00:00:00)
    const currentDate = new Date();
    const currentDateUTC = new Date(Date.UTC(currentDate.getUTCFullYear(), currentDate.getUTCMonth(), currentDate.getUTCDate()));
    // Get the due date and set the time to midnight (00:00:00)
    const dueDate = new Date(input.Payment.DueAmount.Past.DueDate);
    const dueDateUTC = new Date(Date.UTC(dueDate.getUTCFullYear(), dueDate.getUTCMonth(), dueDate.getUTCDate()));
    // Compare the two dates
    if (dueDateUTC < currentDateUTC) {
        return true; // Due date is in the past
    }
    return false; // Due date is today or in the future
}
// var maturesWithin30Days = (acctType == AccountType.Balloon || acctType == AccountType.Lease)
// && maturityDate.Date >= DateTime.Today.Date && maturityDate.Date <= DateTime.Today.AddDays(30).Date;
function MaturesWithin30Days(input) {
    const RightNow = new Date();
    return ((input.Finance.AccountType === enums_1.AccountType.Lease || input.Finance.AccountType === enums_1.AccountType.Loan) &&
        input.CurrentMaturityDate >= RightNow &&
        input.CurrentMaturityDate <= TodayAddDays(30));
}
function TodayAddDays(days) {
    const date = new Date();
    date.setDate(date.getDate() + days);
    return date;
}
function DateDiff(input) {
    const today = new Date();
    const dateDiff = today.getTime() - input.getTime();
    return dateDiff / (1000 * 60 * 60 * 24);
}
//# sourceMappingURL=calculatedFields.js.map